import React, { useState } from "react";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import folderIcon from "../../../../../assets/images/docs/folderIcon.png";
import uploadIcon from "../../../../../assets/images/docs/uploadIcon.png";
import formIcon from "../../../../../assets/images/docs/formIcon.png";
import NewFolder from "../../components/newFolder.jsx";
import RenameItem from "../../components/rename.jsx";
import Move from "../../components/move.jsx";
import { getDocUrl } from "../../../../../redux/docs/getDocUrl";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import AddFolder from "../addFolder/index.jsx";
function DocsSubHeader(props) {
  const {
    classes,
    actionOptions,
    selectedCheckboxIds,
    handleSelectAll,
    isEsign,
    id,
    onSortChange,
    setFolderDetails,
    docsData,
    setOpenDetail,
  } = props;
  const [openNewFolder, setOpenNewFolder] = useState(false);
  const [openRename, setOpenRename] = useState(false);
  const [openMove, setOpenMove] = useState(false);
  const [openAddFolder, setOpenAddFolder] = useState(false);
  const dispatch = useDispatch();

  const handleSortChange = (event) => {
    const value = event.target.value;
    let sortModel = [];

    switch (value) {
      case "name-a-z":
        if (isEsign) {
          sortModel = [{ field: "subject", sort: "asc" }];
        } else {
          sortModel = [{ field: "name", sort: "asc" }];
        }
        break;
      case "name-z-a":
        sortModel = [{ field: "name", sort: "desc" }];
        break;
      case "ownership":
        sortModel = [{ field: "first_name", sort: "asc" }];
        break;
      case "date-modified-newest":
        sortModel = [{ field: "last_updated_at", sort: "desc" }];
        break;
      case "date-modified-oldest":
        sortModel = [{ field: "last_updated_at", sort: "asc" }];
        break;
      case "status":
        sortModel = [{ field: "status", sort: "asc" }];
        break;
      default:
        sortModel = [];
    }

    onSortChange(sortModel);
  };
  const handleSuccess = (data) => {
    if (Array.isArray(data)) {
      data.forEach((url) => {
        window.open(url, "_blank");
      });
    }
  };

  const handleDownload = () => {
    if (selectedCheckboxIds.length === 0) {
      toast.error("Please select a folder to download.");
      return;
    }

    selectedCheckboxIds.forEach((folderId) => {
      dispatch(getDocUrl({ folder_id: folderId, handleSuccess }));
    });
  };

  return (
    <Box className={classes.subHeaderSectionOuter}>
      <Box className={classes.subHeaderSection}>
        {isEsign ? null : (
          <Box
            onClick={() => setOpenNewFolder(true)}
            className={classes.buttonItem}
          >
            <img
              className={classes.buttonIcon}
              src={folderIcon}
              alt="folderIcon"
            />
            <Typography className={classes.buttonText}>Folders</Typography>
          </Box>
        )}
        {isEsign ? null : (
          <Box
            onClick={() => setOpenAddFolder(true)}
            className={classes.buttonItem}
          >
            <img
              className={classes.buttonIcon}
              src={formIcon}
              alt="folderIcon"
            />
            <Typography className={classes.buttonText}>Form</Typography>
          </Box>
        )}
        {isEsign ? null : (
          <Box className={classes.buttonItem} component="label">
            <img
              className={classes.buttonIcon}
              src={uploadIcon}
              alt="folderIcon"
            />
            <Typography className={classes.buttonText}>Upload</Typography>
            <input
              onChange={(e) => console.log(e.target.files[0], "row")}
              hidden
              accept=".pdf"
              multiple
              type="file"
            />
          </Box>
        )}
        <TextField
          select
          size="small"
          defaultValue="sort"
          className={classes.selectBox}
          onChange={handleSortChange}
        >
          <MenuItem disabled value="sort">
            Sort
          </MenuItem>
          <MenuItem value="name-a-z">Name A-Z</MenuItem>
          <MenuItem value="name-z-a">Name Z-A</MenuItem>
          {isEsign ? (
            <MenuItem value="status">Status</MenuItem>
          ) : (
            <MenuItem value="ownership">Ownership</MenuItem>
          )}
          <MenuItem value="date-modified-newest">
            Date Modified (Newest)
          </MenuItem>
          <MenuItem value="date-modified-oldest">
            Date Modified (Oldest)
          </MenuItem>
        </TextField>
        <FormControlLabel
          control={
            <Checkbox
              checked={
                docsData?.length === selectedCheckboxIds?.length &&
                selectedCheckboxIds?.length
              }
              onChange={handleSelectAll}
            />
          }
          label="Select All"
        />
      </Box>
      {selectedCheckboxIds?.length > 0 ? (
        <Box className={classes.subHeaderSectionRight}>
          {actionOptions.map((item, index) => {
            const Icon = item.icon;
            if (selectedCheckboxIds?.length > 1 && item.value === "rename") {
              return null;
            }
            if (selectedCheckboxIds?.length > 1 && item.value === "info") {
              return null;
            }
            return (
              <Box
                onClick={() => {
                  if (item.label === "Rename") {
                    let doc = docsData?.find(
                      (doc) => doc.id === selectedCheckboxIds[0]
                    );
                    if (doc?.type === "folder") {
                      setOpenRename(true);
                      setFolderDetails(doc);
                    } else {
                      toast.error("Rename is only available for folders.", {
                        theme: "colored",
                      });
                    }
                  } else if (item.label === "Move") {
                    setOpenMove(true);
                  } else if (item.label === "Download") {
                    handleDownload();
                  } else if (item.value === "info") {
                    let doc = docsData?.find(
                      (doc) => doc.id === selectedCheckboxIds[0]
                    );
                    setFolderDetails(doc);
                    setOpenDetail(true);
                  }
                }}
                key={index}
                className={classes.buttonItem}
              >
                {item.type === "img" ? (
                  <img
                    className={classes.buttonIcon}
                    src={item.icon}
                    alt={item.label}
                  />
                ) : (
                  <Icon
                    sx={{
                      fontSize: "20px",
                    }}
                  />
                )}
                <Typography className={classes.buttonText}>
                  {item.label}
                </Typography>
              </Box>
            );
          })}
        </Box>
      ) : (
        <Box></Box>
      )}
      <NewFolder open={openNewFolder} setOpen={setOpenNewFolder} id={id} />
      <RenameItem open={openRename} setOpen={setOpenRename} />
      <Move open={openMove} setOpen={setOpenMove} />
      <AddFolder
        open={openAddFolder}
        setOpen={setOpenAddFolder}
        type="add-form"
      />
    </Box>
  );
}

export default withStyles(styleSheet, { name: "DocsSubHeaderStyle" })(
  DocsSubHeader
);
